// extracted by mini-css-extract-plugin
export var siteTitle = "header-module--site-title--h0lve";
export var navLinks = "header-module--nav-links--mDou8";
export var navLinkItem = "header-module--nav-link-item--I972B";
export var navLinkText = "header-module--nav-link-text--nyAs0";